import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
	question: string;
	cancelButtonText: string;
	confirmationButtonText: string;

	constructor(
		private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
		this.question = data.question;
		this.cancelButtonText = data.cancelButtonText;
		this.confirmationButtonText = data.confirmationButtonText;
	}

	ngOnInit() {}

	cancel() {
		this.dialogRef.close("cancel");
	}

	confirm() {
		this.dialogRef.close("confirm");
	}
}
